import React from 'react';

const LoaderDefault = () => <div id="loading" style={{ display: 'block' }} />;
export default LoaderDefault;
